import "./styles.less";

import { Carousel, Col, Row, Space, Tag, Typography } from "antd";
import React, { useContext, useEffect, useState } from "react";

import { CarouselArrow } from "../../../Components/Property/LazyImageGallery/CarouselArrow/web";
import { LocationTag } from "../../../Components/Property/LocationTag/web";
import { PropertyMap } from "../../../Components/Property/PropertyMap/web";
import { useTheme } from "../../../Styles/ThemeHook";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { Map2Icon } from "shared-components/Components/CustomIcons/Map2Icon/web";
import { StreetIcon } from "shared-components/Components/CustomIcons/StreetIcon/web";
import { BookIcon } from "shared-components/Components/CustomIcons/BookIcon/web";
import { Virtual3DIcon } from "shared-components/Components/CustomIcons/Virtual3DIcon/web";

const { Title, Paragraph } = Typography;

// Este es el que se esta usando en AOCUBO
export function PropertyLocalInformation({
	id,
	onMapClick,
	has_map,
	onStreetViewClick,
	onSchoolsClick,
	onTourVirtualClick,
	has_tour3d,
	onBigDataClick,
}) {
	const { theme } = useTheme();

	const data = [
		{
			title: "Mapa",
			paragraph: "Explora la zona que rodea el inmueble.",
			icon: <Map2Icon />,
			event: onMapClick,
			disabled: has_map ? "" : "property-local-information-item-disabled",
		},
		{
			title: "Street View",
			paragraph: "Inicia un recorrido alrededor del inmueble.",
			icon: <StreetIcon />,
			event: onStreetViewClick,
			disabled: "",
		},
		{
			title: "Escuelas y hospitales",
			paragraph: "Explora escuelas y hospitales cercanas al inmueble.",
			icon: <BookIcon />,
			event: onMapClick,
			disabled: "",
		},
		{
			title: "Tour Virtual",
			paragraph: "Inicia un recorrido virtual dentro de la inmueble.",
			icon: <Virtual3DIcon />,
			event: onTourVirtualClick,
			disabled: has_tour3d ? "" : "property-local-information-item-disabled",
		},
	];

	const [settings, setSettings] = useState({
		render: true,
		arrows: true,
		dots: false,
		nextArrow: <CarouselArrow side={"right"} />,
		prevArrow: <CarouselArrow side={"left"} />,
		responsive: [],
		infinite: false,
		speed: 500,
		autoplaySpeed: 5500,
		autoplay: false,
		slidesToShow: 4,
		slidesToScroll: 1,
		variableWidth: true,
	});

	useEffect(() => {
		setSettings({
			...settings,
			render: false,
			responsive: [
				{
					breakpoint: Number(
						theme.breakPoints.md.substring(0, theme.breakPoints.md.length - 2)
					),
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						variableWidth: false,
						infinite: false,
					},
				},
				{
					breakpoint: Number(
						theme.breakPoints.sm.substring(0, theme.breakPoints.sm.length - 2)
					),
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						variableWidth: false,
						infinite: false,
					},
				},
			],
		});
	}, []);

	useEffect(() => {
		if (!settings.render) setSettings({ ...settings, render: true });
	}, [settings.render]);
	if (!settings.render) return null;

	return (
		<div className="property-local-information">
			<Row>
				<Col span={12}>
					<Title level={4}>{"Información Local"}</Title>
				</Col>
				<Col span={12}>
					<LocationTag id={id} />
				</Col>
			</Row>

			<Carousel {...settings}>
				{data.map((item, i) => (
					<div
						style={{ width: 183 }}
						key={"property-local-information" + i}
						onClick={item.event}
						className={"property-local-information-item" + " " + item.disabled}>
						<Row>
							<Col span={24}>
								<div className="image">{item.icon}</div>
							</Col>
							<Col span={24}>
								<Title level={5} className="title">
									{item.title}
								</Title>
							</Col>
							<Col span={24}>
								<Paragraph className="desc">{item.paragraph}</Paragraph>
							</Col>
						</Row>
					</div>
				))}
			</Carousel>
		</div>
	);
}

// Este es el que se esta usando en IC2
export const PropertyLocalInformationMap = ({
	id,
	propId = null,
	onStreetViewClick,
	onMapClick,
	mode = "auto",
	latitude,
	longitude,
	isProject,
	isEspecial = false,
	pointType = false,
	seaDistance = null
}) => {
	const { theme } = useTheme();
	const { country_code } = useContext(ConfigStateContext);
	

	return (
		<div className="property-local-information-map">
			<Row
				gutter={[
					theme.spacing.xsSpacing,
					{ sm: theme.spacing.xsSpacing, xs: theme.spacing.xsSpacing, lg: 0 },
				]}
			>
				{!isEspecial && (
					<Col span={24} className="location">
						<Space align="center">
							<Title level={4}>{"Ubicación"}</Title>
							{(country_code === "ce3" && seaDistance !== null) && <Tag>{seaDistance} {seaDistance !== "frente al mar" && "del mar"}</Tag>}
						</Space>
					</Col>
				)}
				{!isEspecial && (
					<Col span={24} className="address">
						<LocationTag id={id} mode={mode} />
					</Col>
				)}
				<Col span={24} className="map-col">
					<div
						className={`map-container ${isEspecial ? "isEspecial" : ""}`}
						onClick={onMapClick}>
						<PropertyMap
							latitude={latitude}
							longitude={longitude}
							isProject={isProject}
							id={propId || id}
							width={"100%"}
							height={"100%"}
							pointType={pointType}
							options={{
								scrollWheelZoom: false,
								dragging: false,
								zoomControl: false,
							}}
						/>
					</div>

				</Col>
			</Row>
		</div>
	);
};
